import '@/assets/global.css'
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueMarkdownPreview from '@kangc/v-md-editor/lib/preview'
import '@kangc/v-md-editor/lib/style/preview.css'
import * as echarts from 'echarts'
import App from './App.vue'
import router from './router'
import store from './store'
import githubTheme from '@kangc/v-md-editor/lib/theme/github.js'
import highlight from 'highlight.js'

Vue.use(ElementUI)
VueMarkdownPreview.use(githubTheme, { Hljs: highlight })
Vue.use(VueMarkdownPreview)
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false

// Dragscroll directive
const dragscroll = (el) => {
  el.onmousedown = (event) => {
    const startX = event.clientX
    const scrollLeft = el.scrollLeft
    const oldBehavior = el.style['scroll-behavior']
    const oldPointerEvents = el.style['pointer-events']
    el.style['scroll-behavior'] = 'auto'
    document.onmousemove = (e) => {
      e.preventDefault()
      const offsetX = e.clientX - startX
      el.scrollTo(scrollLeft - offsetX, 0)
    }
    document.onmouseup = () => {
      document.onmousemove = null
      document.onmouseup = null
      el.style['scroll-behavior'] = oldBehavior
      el.style['pointer-events'] = oldPointerEvents
    }
  }
}
Vue.directive('dragscroll', dragscroll)

// Responsive font-size
function setRem() {
  const baseSize = 16
  const scale = document.documentElement.clientWidth / 1920
  document.documentElement.style.fontSize = baseSize * Math.min(scale, 2) + 'px'
}
setRem()
window.onresize = function () {
  setRem()
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
